;(function () {
  if (window.__NEW_CUSTOM_COLLECTION_AJAX_INIT__) return
  window.__NEW_CUSTOM_COLLECTION_AJAX_INIT__ = true

  const ROOT = '.new-custom-collection'
  const SORTING = '.collection-sorting'
  const COLLECTION_SECTION =
    '#CollectionSection[data-section-type="collection-template"]'
  const GRID = '.grid-uniform, .grid.grid-collage'
  const PAGINATION = '.pagination'
  const VIEW_MORE_BTN = '.pagination-view-more__btn'
  // URL 筛选参数直接以 group_name 为 key

  // 记录“当前集合状态的 URL”（用于构建 sort_by 等），但不改地址栏
  let currentUrl = window.location.href

  // 全局忙碌态（loading 遮罩）
  let busyCount = 0
  let targetCollectionSectionId = ''

  let preloadRequestId = 0
  let allProductsPreloaded = false   // 全量产品是否已预取到 DOM

  // 当前筛选结果集（筛选激活时使用）
  let filterMatches = []             // 全部匹配产品（DOM 节点）
  let filterShownCount = 0           // 当前已显示数量
  const FILTER_PAGE_SIZE = 24        // 每页显示数量

  function getUrlFromEl(el) {
    if (!el) return ''
    return (
      el.getAttribute('data-url') ||
      el.dataset?.url ||
      el.getAttribute('href') ||
      el.dataset?.href ||
      ''
    )
  }

  function getRootEl() {
    return document.querySelector(ROOT)
  }

  function getCollectionSection(scope = document) {
    const root = scope.querySelector(ROOT)
    const selectorById = targetCollectionSectionId
      ? `${COLLECTION_SECTION}[data-section-id="${targetCollectionSectionId}"]`
      : ''

    if (root && selectorById) {
      const byIdInRoot = root.querySelector(selectorById)
      if (byIdInRoot) return byIdInRoot
    }

    if (root) {
      const sectionInRoot = root.querySelector(COLLECTION_SECTION)
      if (sectionInRoot) return sectionInRoot
    }

    if (selectorById) {
      const byId = scope.querySelector(selectorById)
      if (byId) return byId
    }

    return scope.querySelector(COLLECTION_SECTION)
  }

  function ensureTargetCollectionSectionId() {
    if (targetCollectionSectionId) return targetCollectionSectionId

    const root = document.querySelector(ROOT)
    if (!root) return ''

    const candidates = root.querySelectorAll(COLLECTION_SECTION)
    if (!candidates.length) return ''

    let picked = null
    candidates.forEach((section) => {
      if (picked) return
      if (
        section.querySelector('.collection-sorting') ||
        section.querySelector('.collection-bar-box')
      ) {
        picked = section
      }
    })

    const target = picked || candidates[0]
    targetCollectionSectionId = target?.getAttribute('data-section-id') || ''
    return targetCollectionSectionId
  }

  function getGridEl(scope = document) {
    return getCollectionSection(scope)?.querySelector(GRID) || null
  }

  function getPaginationEl(scope = document) {
    return getCollectionSection(scope)?.querySelector(PAGINATION) || null
  }

  function getProductItems(scope = document) {
    const grid = getGridEl(scope)
    if (grid) {
      const items = Array.from(grid.querySelectorAll(':scope > .grid__item'))
      if (items.length) return items
    }
    return Array.from(
      (scope || document).querySelectorAll(
        '#CollectionSection .grid__item, .CollectionSection-inner .grid__item'
      )
    )
  }

  function getViewMoreButton(scope = document) {
    return getPaginationEl(scope)?.querySelector(VIEW_MORE_BTN) || null
  }

  function getPaginationWrap(scope = document) {
    return (
      getPaginationEl(scope)?.querySelector('.pagination-view-more') || null
    )
  }

  function getPaginationProgress(scope = document) {
    return getPaginationEl(scope)?.querySelector('.pagination-progress') || null
  }

  function ensureLoadingEl(root) {
    if (!root) return null
    let el = root.querySelector('.new-custom-collection__loading')
    if (el) return el

    el = document.createElement('div')
    el.className = 'new-custom-collection__loading'
    el.setAttribute('aria-hidden', 'true')
    el.innerHTML =
      '<span class="new-custom-collection__loading-spinner"></span>'
    root.appendChild(el)
    return el
  }

  function setPageBusy(isBusy) {
    const root = getRootEl()
    if (!root) return
    ensureLoadingEl(root)

    if (isBusy) busyCount += 1
    else busyCount = Math.max(0, busyCount - 1)

    const on = busyCount > 0
    root.classList.toggle('is-loading', on)
    root.setAttribute('aria-busy', on ? 'true' : 'false')
  }

  function recalcProductMetaHeights() {
    const section = getCollectionSection(document)
    if (!section) return
    const boxes = section.querySelectorAll('.CollectionSection-inner .top-box')
    if (!boxes.length) return

    boxes.forEach((b) => {
      b.style.minHeight = '60px'
    })

    let max = 0
    boxes.forEach((b) => {
      const h = b.getBoundingClientRect().height
      if (h > max) max = h
    })

    if (max > 0) {
      boxes.forEach((b) => {
        b.style.minHeight = `${max}px`
      })
    }
  }

  function isCollectionLikeUrl(url) {
    try {
      const u = new URL(url, window.location.href)
      // 只拦截站内 collection 页面相关跳转（含 tag 路径、sort_by、page 等）
      return u.pathname.includes('/collections/')
    } catch {
      return false
    }
  }

  function buildCollectionRequestUrl(targetUrl) {
    try {
      const target = new URL(targetUrl, window.location.href)
      const current = new URL(currentUrl || window.location.href)
      const keepKeys = ['view', 'preview_theme_id', '_ab', '_fd', 'pb']

      keepKeys.forEach((key) => {
        if (!target.searchParams.has(key) && current.searchParams.has(key)) {
          target.searchParams.set(key, current.searchParams.get(key) || '')
        }
      })

      return target.toString()
    } catch {
      return targetUrl
    }
  }

  function setLoading(el, loading) {
    if (!el) return
    el.classList.toggle('is-loading', !!loading)
    if (loading) el.setAttribute('aria-busy', 'true')
    else el.removeAttribute('aria-busy')
  }

  function setDisabled(el, disabled) {
    if (!el) return
    el.classList.toggle('is-disabled', !!disabled)
    el.setAttribute('aria-disabled', disabled ? 'true' : 'false')

    if (el.tagName === 'BUTTON') {
      el.disabled = !!disabled
    } else if (el.tagName === 'A') {
      if (disabled) {
        el.dataset.href = el.getAttribute('href') || ''
        el.removeAttribute('href')
        el.setAttribute('tabindex', '-1')
      } else {
        const href = el.getAttribute('href') || el.dataset.href
        if (href) el.setAttribute('href', href)
        el.removeAttribute('tabindex')
      }
    }
  }

  function setItemHidden(item, hidden) {
    if (!item) return
    if (hidden) {
      item.style.display = 'none'
      item.setAttribute('aria-hidden', 'true')
    } else {
      item.style.display = ''
      item.removeAttribute('aria-hidden')
    }
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html')
  }

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.href).toString()
    } catch {
      return ''
    }
  }

  function getNextPageUrl(scope = document) {
    const pagination = getPaginationEl(scope)
    if (!pagination) return ''

    return (
      pagination.querySelector('.pagination-view-more')?.dataset?.nextUrl ||
      getUrlFromEl(pagination.querySelector(VIEW_MORE_BTN)) ||
      pagination.querySelector('a[rel="next"]')?.getAttribute('href') ||
      ''
    )
  }

  function updateProgress(visibleCount, totalCount) {
    const progress = getPaginationProgress(document)
    if (!progress) return

    const fill = progress.querySelector('.pagination-progress__fill')
    const safeTotal = Math.max(1, Number(totalCount) || 0)
    const safeVisible = Math.max(
      0,
      Math.min(Number(visibleCount) || 0, safeTotal)
    )
    const pct = Math.min(100, Math.max(0, (safeVisible / safeTotal) * 100))

    progress.setAttribute('aria-valuemin', '0')
    progress.setAttribute('aria-valuemax', String(safeTotal))
    progress.setAttribute('aria-valuenow', String(safeVisible))

    if (fill) {
      fill.style.width = `${pct}%`
      fill.style.transform = 'none'
    }
  }

  function updateViewMoreUI({ pageSize, visibleCount, totalCount, nextUrl = '' }) {
    const btn = getViewMoreButton(document)
    const wrap = getPaginationWrap(document)
    if (!btn || !wrap) return

    const safePageSize = Math.max(1, Number(pageSize) || 1)
    const safeTotal = Math.max(0, Number(totalCount) || 0)
    const safeVisible = Math.max(0, Math.min(Number(visibleCount) || 0, safeTotal))

    wrap.dataset.pageSize = String(safePageSize)
    wrap.dataset.visibleCount = String(safeVisible)
    wrap.dataset.totalCount = String(safeTotal)
    wrap.dataset.nextUrl = nextUrl || ''

    if (safeVisible >= safeTotal) {
      btn.removeAttribute('data-url')
      setDisabled(btn, true)
    } else {
      if (nextUrl) btn.setAttribute('data-url', nextUrl)
      setDisabled(btn, false)
    }

    updateProgress(safeVisible, safeTotal)
  }

  function getCheckedFilterInputs() {
    const sidebar = document.getElementById('CollectionSidebarFilter')
    if (!sidebar) return []
    return Array.from(sidebar.querySelectorAll('input[data-group]:checked'))
  }

  /**
   * 收集侧边栏所有 group 名称（用于清除 URL 参数）
   */
  function getFilterGroupNames() {
    const sidebar = document.getElementById('CollectionSidebarFilter')
    if (!sidebar) return []
    const names = new Set()
    sidebar.querySelectorAll('input[data-group]').forEach((input) => {
      const g = (input.getAttribute('data-group') || '').trim()
      if (g) names.add(g)
    })
    return Array.from(names)
  }

  /**
   * 将当前选中的筛选条件写入 URL
   * 格式：?GroupName=option1,option2&OtherGroup=option3
   */
  function pushFilterStateToUrl() {
    const checked = getCheckedFilterInputs()
    const url = new URL(window.location.href)

    // 先清除所有已知 group 的参数
    getFilterGroupNames().forEach((name) => url.searchParams.delete(name))

    // 按 group 分组，逗号拼接
    const groups = new Map()
    checked.forEach((input) => {
      const group = (input.getAttribute('data-group') || '').trim()
      const option = (input.getAttribute('data-option-name') || input.value || '').trim()
      if (!group || !option) return
      if (!groups.has(group)) groups.set(group, [])
      groups.get(group).push(option)
    })

    groups.forEach((options, group) => {
      url.searchParams.set(group, options.join(','))
    })

    history.replaceState({ url: url.toString() }, '', url.toString())
  }

  /**
   * 从 URL 参数还原筛选勾选状态
   * 返回 true 表示至少有一个条件被还原
   */
  function restoreFilterStateFromUrl() {
    const sidebar = document.getElementById('CollectionSidebarFilter')
    if (!sidebar) return false

    const url = new URL(window.location.href)
    const groupNames = getFilterGroupNames()
    let restored = 0

    groupNames.forEach((group) => {
      const val = url.searchParams.get(group)
      if (!val) return
      val.split(',').map((s) => s.trim()).filter(Boolean).forEach((option) => {
        const inputs = sidebar.querySelectorAll('input[data-group]')
        for (const input of inputs) {
          if (
            input.getAttribute('data-group') === group &&
            (input.getAttribute('data-option-name') || input.value) === option
          ) {
            input.checked = true
            restored++
            break
          }
        }
      })
    })

    return restored > 0
  }

  /**
   * 清除 URL 中所有筛选参数（collection/sort 切换时调用）
   */
  function clearFilterUrlParams() {
    const url = new URL(window.location.href)
    const groupNames = getFilterGroupNames()
    let changed = false
    groupNames.forEach((name) => {
      if (url.searchParams.has(name)) {
        url.searchParams.delete(name)
        changed = true
      }
    })
    if (changed) history.replaceState({ url: url.toString() }, '', url.toString())
  }

  function getCardPrice(item) {
    const raw =
      item.getAttribute('data-product-price') ||
      item.querySelector('[data-product-price]')?.getAttribute('data-product-price') ||
      ''
    const price = Number(raw)
    return Number.isFinite(price) ? price : null
  }

  function isPriceFilterInput(input) {
    return (
      String(input.getAttribute('data-group') || '')
        .trim()
        .toLowerCase() === 'price'
    )
  }

  /**
   * 从后台选项名称解析价格区间，例如：
   * Under $150 / $150-$200 / Above $200 / $500-$1,000
   */
  function getPriceRangeFromInput(input) {
    const label = String(
      input.getAttribute('data-option-name') ||
        input.getAttribute('data-price-range') ||
        input.value ||
        ''
    )
      .trim()
      .toLowerCase()
      .replace(/–/g, '-')
      .replace(/,/g, '')

    const amounts = label.match(/\d+(?:\.\d+)?/g)?.map(Number) || []
    if (!amounts.length) return null

    if (/\b(above|over)\b/.test(label)) {
      return { min: amounts[0], max: Infinity, exclusiveMin: true }
    }
    if (/\b(under|below)\b/.test(label)) {
      return { min: 0, max: amounts[0], exclusiveMax: true }
    }
    if (amounts.length >= 2) {
      return { min: Math.min(amounts[0], amounts[1]), max: Math.max(amounts[0], amounts[1]) }
    }
    return null
  }

  function productMatchesPriceRange(price, range) {
    if (price == null || !range) return false
    if (range.exclusiveMin) return price > range.min
    if (range.exclusiveMax) return price < range.max
    return price >= range.min && price <= range.max
  }

  function sortVisibleProductsByPrice(ascending = true) {
    const grid = getGridEl(document)
    if (!grid) return
    const cards = getAllProductCards(document)
    if (!cards.length) return

    const sorted = [...cards].sort((a, b) => {
      const pa = getCardPrice(a)
      const pb = getCardPrice(b)
      const na = pa == null ? Number.POSITIVE_INFINITY : pa
      const nb = pb == null ? Number.POSITIVE_INFINITY : pb
      return ascending ? na - nb : nb - na
    })
    sorted.forEach((card) => grid.appendChild(card))
  }

  function updateFilterCount(count) {
    const safeCount = Math.max(0, Number(count) || 0)
    document.querySelectorAll('.filter-count-num').forEach((el) => {
      el.textContent = String(safeCount)
    })
    // 同步排序区标题：xx products（仅带 data-product-count-title 的节点）
    document.querySelectorAll('[data-product-count-title]').forEach((el) => {
      const suffixOne = el.getAttribute('data-count-suffix-one') || 'product'
      const suffixMany = el.getAttribute('data-count-suffix') || 'products'
      const suffix = safeCount === 1 ? suffixOne : suffixMany
      el.textContent = `${safeCount} ${suffix}`
    })
  }

  function updateSelectedFilterNumber(count) {
    const filterNumbers = document.querySelectorAll('.filter-number')
    // sync selected filter badge count
    filterNumbers.forEach((filterNumber) => {
      filterNumber.style.display = count > 0 ? 'inline-flex' : 'none';
      filterNumber.textContent = String(count)
    })
  }

  function syncEmptyState(showEmpty) {
    const emptyEl =
      getCollectionSection()?.querySelector('[data-filter-empty]') ||
      document.querySelector('[data-filter-empty]')
    const paginationEl = getPaginationEl(document)

    if (showEmpty) {
      if (emptyEl) emptyEl.hidden = false
      if (paginationEl) paginationEl.style.display = 'none'
    } else {
      if (emptyEl) emptyEl.hidden = true
      if (paginationEl) paginationEl.style.display = ''
    }
  }

  function productMatchesFilter(cardHandle, cardId, filterSet) {
    if (cardId && filterSet.ids.has(cardId)) return true
    if (!cardHandle || !filterSet.handles.size) return false
    if (filterSet.handles.has(cardHandle)) return true

    for (const h of filterSet.handles) {
      if (cardHandle === h) return true
      if (cardHandle.startsWith(h + '-') || h.startsWith(cardHandle + '-')) return true
    }
    return false
  }

  function itemMatchesCurrentFilters(
    item,
    checkedInputs = getCheckedFilterInputs()
  ) {
    if (!checkedInputs.length) return true

    const cardHandle = (
      item.getAttribute('data-product-handle') ||
      item
        .querySelector('[data-product-handle]')
        ?.getAttribute('data-product-handle') ||
      ''
    )
      .trim()
      .toLowerCase()
    const cardId = String(
      item.getAttribute('data-product-id') ||
        item
          .querySelector('[data-product-id]')
          ?.getAttribute('data-product-id') ||
        ''
    ).trim()
    const cardPrice = getCardPrice(item)

    // 所有勾选项取交集 (AND)：组内、组间都必须命中
    return checkedInputs.every((input) => {
      // Price：按当前卡片价格区间过滤，不依赖 products
      if (isPriceFilterInput(input)) {
        const range = getPriceRangeFromInput(input)
        return productMatchesPriceRange(cardPrice, range)
      }

      const handlesAttr = input.getAttribute('data-product-handles') || ''
      const idsAttr = input.getAttribute('data-product-ids') || ''
      const handles = handlesAttr
        .split(',')
        .map((h) => h.trim().toLowerCase())
        .filter(Boolean)
      const ids = idsAttr
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)

      if (!handles.length && !ids.length) return false

      return productMatchesFilter(cardHandle, cardId, {
        handles: new Set(handles),
        ids: new Set(ids),
      })
    })
  }

  function getAllProductCards(scope = document) {
    return getProductItems(scope).filter((item) =>
      item.classList.contains('grid-product')
    )
  }

  function getPaginationCounts() {
    const wrap = getPaginationWrap(document)
    // 保留 collection 原始总数，避免被后续逻辑改写
    if (wrap && !wrap.dataset.collectionTotal && wrap.dataset.totalCount) {
      wrap.dataset.collectionTotal = wrap.dataset.totalCount
    }
    const totalCount = Math.max(
      0,
      Number(wrap?.dataset?.collectionTotal) ||
        Number(wrap?.dataset?.totalCount) ||
        0
    )
    const visibleCount = Math.max(0, Number(wrap?.dataset?.visibleCount) || 0)
    const pageSize = Math.max(1, Number(wrap?.dataset?.pageSize) || 24)
    return { wrap, totalCount, visibleCount, pageSize }
  }

  function syncViewMoreButtonState() {
    const btn = getViewMoreButton(document)
    const { wrap, totalCount, visibleCount } = getPaginationCounts()
    if (!btn || !wrap) return

    const nextUrl =
      wrap.dataset.nextUrl ||
      getUrlFromEl(btn) ||
      getNextPageUrl(document) ||
      ''
    const hasMore = visibleCount < totalCount && Boolean(nextUrl)

    if (hasMore) {
      wrap.dataset.nextUrl = nextUrl
      btn.setAttribute('data-url', nextUrl)
      setDisabled(btn, false)
    } else {
      setDisabled(btn, true)
      if (totalCount > 0 && visibleCount >= totalCount) {
        wrap.dataset.nextUrl = ''
        btn.removeAttribute('data-url')
      }
    }

    // pagination 上的 total 始终表示 collection 总数
    wrap.dataset.totalCount = String(totalCount)
    updateProgress(visibleCount, totalCount)
  }

  /**
   * 将当前页全部产品设置为"前 pageSize 可见，其余隐藏"，并更新分页 UI
   */
  function setupLocalViewMore({ pageSize }) {
    const items = getProductItems(document)
    const totalCount = items.length
    if (!totalCount) return

    const safePageSize = Math.max(1, Number(pageSize) || 1)
    const visibleCount = Math.min(safePageSize, totalCount)

    // 筛选态不重置可见性，由 applySidebarFilters 管理
    if (filterMatches.length === 0) {
      items.forEach((item, index) => {
        setItemHidden(item, index >= visibleCount)
      })
    }

    updateViewMoreUI({ pageSize: safePageSize, visibleCount, totalCount, nextUrl: '' })
    lazySizesRecheck()
    dispatchUpdated()
  }

  /**
   * 从 DOM 显示下一批隐藏的产品（非筛选态 View More）
   */
  function revealNextChunk(btn) {
    const wrap = btn?.closest('.pagination-view-more') || getPaginationWrap(document)
    if (!wrap) return

    const items = getProductItems(document)
    const totalCount = items.length
    if (!totalCount) {
      updateViewMoreUI({ pageSize: 1, visibleCount: 0, totalCount: 0, nextUrl: '' })
      return
    }

    const pageSize = Math.max(
      1,
      Number(wrap.dataset.pageSize) ||
        Number(getCollectionSection(document)?.getAttribute('data-page-size')) ||
        FILTER_PAGE_SIZE
    )
    const visibleCount = Math.max(0, Number(wrap.dataset.visibleCount) || 0)
    const nextVisibleCount = Math.min(totalCount, visibleCount + pageSize)

    let firstRevealedItem = null
    for (let i = visibleCount; i < nextVisibleCount; i++) {
      setItemHidden(items[i], false)
      if (!firstRevealedItem) firstRevealedItem = items[i]
    }

    updateViewMoreUI({ pageSize, visibleCount: nextVisibleCount, totalCount, nextUrl: '' })
    lazySizesRecheck()
    dispatchUpdated()

    if (firstRevealedItem) {
      setTimeout(() => {
        firstRevealedItem.setAttribute('tabindex', '-1')
        firstRevealedItem.focus({ preventScroll: true })
      }, 50)
    }
  }

  /**
   * 后台静默预取所有分页，将产品追加到 DOM（hidden），完成后更新分页 UI
   */
  async function preloadAllProductsForCurrentState(url) {
    const currentRequestId = ++preloadRequestId
    allProductsPreloaded = false

    const currentGrid = getGridEl(document)
    if (!currentGrid) return

    const initialItems = getProductItems(document)
    const pageSize = Math.max(1, initialItems.length || FILTER_PAGE_SIZE)

    let nextUrl = getNextPageUrl(document)
    const visited = new Set()
    const btn = getViewMoreButton(document)
    if (btn) setLoading(btn, true)

    try {
      while (nextUrl) {
        if (currentRequestId !== preloadRequestId) return

        const requestUrl = buildCollectionRequestUrl(nextUrl)
        const normalized = normalizeUrl(requestUrl)
        if (!normalized || visited.has(normalized)) break
        visited.add(normalized)

        const res = await fetch(requestUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
        if (!res.ok) throw new Error('HTTP ' + res.status)

        const doc = parseHTML(await res.text())
        const incomingGrid = getGridEl(doc)
        if (!incomingGrid) break

        const newItems = incomingGrid.querySelectorAll(':scope > .grid__item')
        if (!newItems.length) break

        const fragment = document.createDocumentFragment()
        newItems.forEach((n) => {
          setItemHidden(n, true)
          fragment.appendChild(n)
        })
        currentGrid.appendChild(fragment)
        nextUrl = getNextPageUrl(doc)
      }

      allProductsPreloaded = true
      if (url) currentUrl = url

      // 预取完成后：筛选态直接重新应用（跳过 setupLocalViewMore，避免覆盖筛选结果）
      if (filterMatches.length > 0 || getCheckedFilterInputs().length > 0) {
        restoreFilterStateFromUrl()
        applySidebarFilters()
      } else {
        // 非筛选态：正常设置分页
        setupLocalViewMore({ pageSize })
      }
    } finally {
      if (btn) setLoading(btn, false)
    }
  }

  /**
   * 筛选态：同步分页按钮状态（纯客户端，不依赖 nextUrl）
   */
  function syncFilterPagination(shownCount, totalCount) {
    const pagination = getPaginationEl(document)
    const btn = getViewMoreButton(document)
    const wrap = getPaginationWrap(document)

    const hasMore = shownCount < totalCount

    if (pagination) pagination.style.display = totalCount === 0 ? 'none' : ''
    if (btn) setDisabled(btn, !hasMore)
    if (wrap) {
      wrap.dataset.visibleCount = String(shownCount)
      wrap.dataset.totalCount = String(totalCount)
      // 预取完成前保留服务器提供的下一页 URL，供后台加载全量商品。
      if (allProductsPreloaded) wrap.dataset.nextUrl = ''
      if (btn) btn.removeAttribute('data-url')
    }
    updateProgress(shownCount, totalCount)
    updateFilterCount(totalCount)
  }

  /**
   * 纯前端侧边栏筛选
   * - 无 filter：恢复正常分页（前 pageSize 可见，其余隐藏）
   * - 有 filter：匹配 DOM 中所有产品（含预取的隐藏项），先显示前 24 条
   */
  function applySidebarFilters() {
    const checked = getCheckedFilterInputs()

    const abovePriceChecked = checked.some((input) => {
      if (!isPriceFilterInput(input)) return false
      const range = getPriceRangeFromInput(input)
      return range && range.exclusiveMin
    })

    // ── 无筛选：恢复正常分页 ─────────────────────────────────────────
    if (!checked.length) {
      filterMatches = []
      filterShownCount = 0

      const { wrap, totalCount: collectionTotal } = getPaginationCounts()
      const pageSize = Math.max(
        1,
        Number(wrap?.dataset?.pageSize) ||
          Number(getCollectionSection(document)?.getAttribute('data-page-size')) ||
          FILTER_PAGE_SIZE
      )
      const items = getProductItems(document)
      items.forEach((item, index) => setItemHidden(item, index >= pageSize))

      // 预取完成前保留 Liquid 输出的 collection 总数和下一页 URL；预取完成后
      // 才由已经追加到 DOM 的全量商品接管本地 View More。
      const total = allProductsPreloaded
        ? items.length
        : Math.max(collectionTotal, items.length)
      const visibleCount = Math.min(pageSize, items.length, total)

      if (allProductsPreloaded) {
        updateViewMoreUI({ pageSize, visibleCount, totalCount: total, nextUrl: '' })
      } else {
        if (wrap) {
          wrap.dataset.visibleCount = String(visibleCount)
          wrap.dataset.totalCount = String(total)
          if (!wrap.dataset.collectionTotal) {
            wrap.dataset.collectionTotal = String(total)
          }
        }
        syncViewMoreButtonState()
      }
      syncEmptyState(false)
      updateSelectedFilterNumber(0)
      updateFilterCount(total)
      recalcProductMetaHeights()
      lazySizesRecheck()
      return
    }

    // ── 有筛选：匹配 DOM 中全部产品（包含预取的隐藏项） ─────────────
    const allCards = getAllProductCards(document)

    let matches = allCards.filter((card) => itemMatchesCurrentFilters(card, checked))

    // Above $1,000 价格排序
    if (abovePriceChecked) {
      matches = matches.slice().sort((a, b) => {
        const pa = getCardPrice(a) ?? Infinity
        const pb = getCardPrice(b) ?? Infinity
        return pa - pb
      })
    }

    filterMatches = matches
    filterShownCount = Math.min(FILTER_PAGE_SIZE, matches.length)

    // 先隐藏所有产品，再显示匹配的前 FILTER_PAGE_SIZE 个
    allCards.forEach((card) => setItemHidden(card, true))
    matches.slice(0, filterShownCount).forEach((card) => setItemHidden(card, false))

    syncEmptyState(matches.length === 0)
    updateSelectedFilterNumber(checked.length)
    syncFilterPagination(filterShownCount, matches.length)
    recalcProductMetaHeights()
    lazySizesRecheck()
  }

  /**
   * 筛选态 View More：从 DOM 的 filterMatches 中显示下一批，不发网络请求
   */
  function handleFilterViewMore(btn) {
    if (!filterMatches.length || filterShownCount >= filterMatches.length) return false

    const nextEnd = Math.min(filterShownCount + FILTER_PAGE_SIZE, filterMatches.length)
    if (btn) setLoading(btn, true)
    try {
      filterMatches.slice(filterShownCount, nextEnd).forEach((card) => setItemHidden(card, false))
      filterShownCount = nextEnd
      syncFilterPagination(filterShownCount, filterMatches.length)
      recalcProductMetaHeights()
      lazySizesRecheck()
      return filterShownCount < filterMatches.length
    } finally {
      if (btn) setLoading(btn, false)
    }
  }

  /**
   * View More：
   * - 筛选态：从 DOM filterMatches 显示下一批（无网络请求）
   * - 非筛选态：若预取完成则 revealNextChunk，否则发网络请求
   */
  async function handleViewMoreClick(btn) {
    // 筛选态
    if (filterMatches.length > 0) {
      return handleFilterViewMore(btn)
    }

    // 非筛选态：检查 DOM 中是否还有隐藏的预取产品
    const wrap = getPaginationWrap(document)
    const items = getProductItems(document)
    const visibleCount = Math.max(0, Number(wrap?.dataset?.visibleCount) || 0)

    if (allProductsPreloaded || visibleCount < items.length) {
      revealNextChunk(btn)
      return true
    }

    // 没有预取产品，尝试网络请求下一页
    const { totalCount, pageSize } = getPaginationCounts()
    if (!wrap) return false
    if (totalCount > 0 && visibleCount >= totalCount) {
      syncViewMoreButtonState()
      return false
    }

    const rawUrl = getUrlFromEl(btn) || wrap.dataset.nextUrl || getNextPageUrl(document)
    if (!rawUrl) {
      syncViewMoreButtonState()
      return false
    }

    const url = buildCollectionRequestUrl(rawUrl)
    const liveBtn = btn || getViewMoreButton(document)
    if (liveBtn) setLoading(liveBtn, true)

    try {
      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!res.ok) throw new Error('HTTP ' + res.status)

      const doc = parseHTML(await res.text())
      const currentGrid = getGridEl(document)
      const incomingGrid = getGridEl(doc)
      let appended = 0

      if (currentGrid && incomingGrid) {
        const newItems = Array.from(incomingGrid.querySelectorAll(':scope > .grid__item'))
        const fragment = document.createDocumentFragment()
        newItems.forEach((n) => {
          fragment.appendChild(n)
          if (n.classList.contains('grid-product')) appended++
        })
        currentGrid.appendChild(fragment)
      }

      const nextWrap = getPaginationWrap(doc)
      const nextUrl = nextWrap?.dataset?.nextUrl || getNextPageUrl(doc) || ''
      const loadedInDom = getAllProductCards(document).length
      const safeTotal =
        totalCount ||
        Number(wrap.dataset.collectionTotal) ||
        Number(nextWrap?.dataset?.totalCount) ||
        loadedInDom
      if (!wrap.dataset.collectionTotal) wrap.dataset.collectionTotal = String(safeTotal)
      const nextVisible = Math.min(safeTotal, Math.max(visibleCount + (appended || pageSize), loadedInDom))

      wrap.dataset.visibleCount = String(nextVisible)
      wrap.dataset.totalCount = String(safeTotal)
      wrap.dataset.nextUrl = nextUrl

      const btnToUpdate = liveBtn || getViewMoreButton(document)
      if (btnToUpdate) {
        if (nextUrl) btnToUpdate.setAttribute('data-url', nextUrl)
        else btnToUpdate.removeAttribute('data-url')
      }
      return appended > 0 || Boolean(nextUrl)
    } catch (err) {
      console.error('[new-custom-collection ajax] view more fetch failed', err)
      return false
    } finally {
      const btnToUpdate = liveBtn || getViewMoreButton(document)
      if (btnToUpdate) setLoading(btnToUpdate, false)
      syncViewMoreButtonState()
    }
  }

  function lazySizesRecheck() {
    if (window.lazySizes?.autoSizer?.checkElems)
      window.lazySizes.autoSizer.checkElems()
  }

  function dispatchUpdated() {
    document.dispatchEvent(new CustomEvent('newCustomCollection:updated'))
  }

  function replaceProductsAndPaginationFromDoc(doc) {
    const nextSection = getCollectionSection(doc)
    const curSection = getCollectionSection(document)
    if (!nextSection || !curSection) return false

    const nextGrid = nextSection.querySelector(GRID)
    const curGrid = curSection.querySelector(GRID)
    if (!nextGrid || !curGrid) return false

    curGrid.replaceWith(nextGrid)
    const liveGrid = curSection.querySelector(GRID) || nextGrid

    const nextPagination = nextSection.querySelector(PAGINATION)
    const curPagination = curSection.querySelector(PAGINATION)
    if (nextPagination && curPagination) {
      curPagination.replaceWith(nextPagination)
    } else if (nextPagination && !curPagination) {
      liveGrid.insertAdjacentElement('afterend', nextPagination)
    } else if (!nextPagination && curPagination) {
      curPagination.remove()
    }

    return true
  }

  function replacePagePartsFromDoc(doc) {
    const curRoot = document.querySelector(ROOT) || document
    ensureTargetCollectionSectionId()

    // 1) 替换排序条
    const nextSort = doc.querySelector(SORTING)
    const curSort = document.querySelector(SORTING)
    if (nextSort && curSort) {
      curSort.replaceWith(nextSort)
    }

    // 2) 替换产品列表与分页
    replaceProductsAndPaginationFromDoc(doc)
    lazySizesRecheck()
    dispatchUpdated()
  }

  async function fetchAndReplace(
    url,
    { pushState = false, scrollToSection = true } = {}
  ) {
    // 仅改 sort_by 时保留筛选；切换 collection 时再清空
    const isSameCollection = (() => {
      try {
        const cur = new URL(currentUrl, window.location.href)
        const next = new URL(url, window.location.href)
        return cur.pathname === next.pathname
      } catch {
        return false
      }
    })()

    setPageBusy(true)
    try {
      const res = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      })
      if (!res.ok) throw new Error('HTTP ' + res.status)

      const html = await res.text()
      const doc = parseHTML(html)

      filterMatches = []
      filterShownCount = 0
      allProductsPreloaded = false
      if (!isSameCollection) clearFilterUrlParams()

      replacePagePartsFromDoc(doc)
      if (pushState) history.pushState({ url }, '', url)

      if (scrollToSection) {
        const section = getCollectionSection(document)
        if (section)
          section.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    } finally {
      setPageBusy(false)
    }

    // 释放遮罩后立即应用筛选（sort 保留条件可即时生效；新 collection 无筛选则无操作）
    if (isSameCollection) {
      restoreFilterStateFromUrl()
    }
    applySidebarFilters()

    // 静默后台预取，不阻塞交互
    preloadAllProductsForCurrentState(url).catch((err) =>
      console.error('[new-custom-vacuum-collection ajax] preload failed', err)
    )
  }

  function buildUrlWithSortBy(sortBy) {
    // 只更新 sort_by，保留地址栏中的全部其他参数（包括自定义筛选条件）
    const u = new URL(window.location.href)
    if (!sortBy) u.searchParams.delete('sort_by')
    else u.searchParams.set('sort_by', sortBy)
    return u.toString()
  }

  // 事件：排序 select / 侧边栏筛选
  document.addEventListener('change', (e) => {
    if (e.target.closest('#CollectionSidebarFilter, .collection-sidebar-filter')) {
      if (
        e.target.matches(
          'input[type="checkbox"], input[type="radio"], input[data-product-handles]'
        )
      ) {
        // 只过滤当前已加载产品，不自动翻页请求
        applySidebarFilters()
        pushFilterStateToUrl()
      }
      return
    }

    const root = e.target.closest(ROOT)
    if (!root) return

    if (e.target.matches('.filter-dropdown__select')) {
      // 阻止主题旧的排序监听器再次用只有 sort_by 的 URL 覆盖筛选参数
      e.stopImmediatePropagation()

      const url = buildUrlWithSortBy(e.target.value)
      history.replaceState({ url }, '', url)
      fetchAndReplace(url, { pushState: false }).catch((err) =>
        console.error('[new-custom-collection ajax] sort failed', err)
      )
    }
  }, true)

  // 事件：点击（tag 链接 / 分页 / View More）
  document.addEventListener('click', (e) => {
    // A) View More：完全走主题标准 AJAX 加载下一页
    const vmWrap = e.target.closest('.pagination-view-more')
    const vmBtn =
      e.target.closest(VIEW_MORE_BTN) ||
      (vmWrap ? vmWrap.querySelector(VIEW_MORE_BTN) : null)

    if (vmWrap || vmBtn) {
      const btn = vmBtn || vmWrap.querySelector(VIEW_MORE_BTN)
      if (!btn) return

      e.preventDefault()
      e.stopPropagation()

      if (
        btn.classList.contains('is-disabled') ||
        btn.getAttribute('aria-disabled') === 'true' ||
        btn.disabled ||
        btn.classList.contains('is-loading')
      ) {
        return
      }

      handleViewMoreClick(btn)
      return
    }

  })

  // Sidebar Filter Implementation
  /** 按后台字段分组：group_name / filter_type / option_name / products / group_tooltip */
  function initSidebarFilters() {
    const wrapper = document.getElementById('FilterGroupsWrapper')
    if (!wrapper) return

    bindSidebarEvents()
  }
  function bindSidebarAccordionOnce() {
    if (window.__sidebarFilterAccordionBound) return
    window.__sidebarFilterAccordionBound = true

    document.addEventListener('click', (e) => {
      if (window.innerWidth < 850) return
      if (e.target.closest('.group-info')) return
      const header = e.target.closest(
        '#CollectionSidebarFilter .filter-group-header'
      )
      if (!header) return
      const item = header.closest('.filter-group-item')
      if (!item) return
      item.classList.toggle('collapsed')
    })
  }

  function bindSidebarEvents() {
    const sidebar = document.getElementById('CollectionSidebarFilter')
    if (!sidebar) {
      bindFilterEmptyReset()
      return
    }

    bindSidebarAccordionOnce()

    if (sidebar.dataset.filterBound !== 'true') {
      sidebar.dataset.filterBound = 'true'

      sidebar.querySelectorAll('.filter-clear-all-btn').forEach((btn) => {
        btn.addEventListener('click', () => {
          resetSidebarFilters()
        })
      })

      const tabsCol = document.getElementById('MobileFilterTabs')
      if (tabsCol && tabsCol.dataset.bound !== 'true') {
        tabsCol.dataset.bound = 'true'
        tabsCol.addEventListener('click', (e) => {
          const tab = e.target.closest('.mobile-tab-item')
          if (!tab) return
          const idx = tab.getAttribute('data-group-index')

          tabsCol.querySelectorAll('.mobile-tab-item').forEach((t) => {
            t.classList.remove('is-active')
          })
          tab.classList.add('is-active')

          const groupItems = document.querySelectorAll('#FilterGroupsWrapper .filter-group-item')
          groupItems.forEach((item, index) => {
            if (String(index) === String(idx)) {
              item.classList.add('mobile-active')
            } else {
              item.classList.remove('mobile-active')
            }
          })
        })
      }

      const mobBtn = document.querySelector('.mobile-filter-btn')
      const overlay = document.querySelector('.mobile-filter-overlay')
      if (mobBtn && mobBtn.dataset.filterBound !== 'true') {
        mobBtn.dataset.filterBound = 'true'
        mobBtn.addEventListener('click', () => {
          sidebar.classList.add('is-open')
          overlay?.classList.add('is-open')
        })
      }
      if (overlay && overlay.dataset.filterBound !== 'true') {
        overlay.dataset.filterBound = 'true'
        overlay.addEventListener('click', () => {
          sidebar.classList.remove('is-open')
          overlay.classList.remove('is-open')
        })
      }
    }

    bindFilterEmptyReset()
  }

  function resetSidebarFilters() {
    const sidebar = document.getElementById('CollectionSidebarFilter')
    if (!sidebar) return
    sidebar.querySelectorAll('input[data-group], input[data-product-handles]').forEach((input) => {
      input.checked = false
    })
    applySidebarFilters()
    clearFilterUrlParams()
  }

  function bindFilterEmptyReset() {
    document.querySelectorAll('[data-filter-reset]').forEach((btn) => {
      if (btn.dataset.resetBound === 'true') return
      btn.dataset.resetBound = 'true'
      btn.addEventListener('click', () => {
        resetSidebarFilters()
      })
    })
  }

  // 每次局部更新后：重建侧边栏
  document.addEventListener('newCustomCollection:updated', () => {
    const sidebar = document.getElementById('CollectionSidebarFilter')
    if (sidebar) sidebar.dataset.filterBound = ''
    initSidebarFilters()
    recalcProductMetaHeights()
  })

  // 首屏初始化
  ensureTargetCollectionSectionId()
  recalcProductMetaHeights()
  initSidebarFilters()
  // 从 URL 参数还原筛选勾选状态，再触发筛选
  restoreFilterStateFromUrl()
  applySidebarFilters()
  // 后台静默预取全量产品到 DOM
  preloadAllProductsForCurrentState(currentUrl).catch((err) =>
    console.error('[new-custom-collection ajax] preload failed', err)
  )

  // 后退/前进：拉取对应 URL 并替换，完成后根据 URL 参数还原筛选状态
  window.addEventListener('popstate', () => {
    if (!document.querySelector(ROOT)) return
    if (!isCollectionLikeUrl(window.location.href)) return
    fetchAndReplace(window.location.href, {
      pushState: false,
      scrollToSection: false,
    })
      .then(() => {
        // 先清空所有已勾选的筛选，再从新 URL 还原
        const sidebar = document.getElementById('CollectionSidebarFilter')
        if (sidebar) {
          sidebar.querySelectorAll('input[data-group]:checked').forEach((input) => {
            input.checked = false
          })
        }
        restoreFilterStateFromUrl()
        applySidebarFilters()
      })
      .catch((err) =>
        console.error('[new-custom-collection ajax] popstate failed', err)
      )
  })
})()